import { Api, ApiUrl } from "../../services";
import { mutations as MUTATION, actions as ACTION } from "./types";
import { PAGE_DEFAULT_TITLE } from "@/contants/page";
import { cloneDeep } from "@/shared";
import { checkKeyValid } from "@/utils/globalConfigs";

export const transformPageType = originalType => {
  switch (originalType) {
    case "subpages":
      return "template-page";
    case "landingpages":
      return "template-page";
    case "articlepages":
      return "template-article";
    case "homepages":
      return "template-index";
    case "productpages":
      return "template-product";
    case "collectionpages":
      return "template-collection";
    default:
      return "";
  }
};

export const transformPageName = originalType => {
  const data = {
    subpages: "Landing Page",
    landingpages: "Landing Page",
    articlepages: "Blog Post",
    homepages: "Home Page",
    productpages: "Product Page",
    collectionpages: "Collection Page"
  };
  return data[originalType];
};

function formatDate(date) {
  const month = new Date().toLocaleDateString("en-us", { month: "short" });
  return `${month} ${date.getDate()}, ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
}

export const generatePageTitle = () => {
  const date = formatDate(new Date());
  const pageTitle = `Untitled - ${date}`;
  return pageTitle;
};

export const getPageListName = type => {
  let pageList = "";
  switch (type) {
    case "template-page":
      pageList = "subpages";
      break;
    case "template-article":
      pageList = "articlepages";
      break;
    case "template-index":
      pageList = "homepages";
      break;
    case "template-product":
      pageList = "productpages";
      break;
    case "template-collection":
      pageList = "collectionpages";
      break;
  }
  return pageList;
};

let transformPageMeta = originType => {
  switch (originType) {
    case "productpages":
      return "assignProductTemplates";
    case "collectionpages":
      return "assignCollectionTemplates";
  }
};

let commitStatus = (mutationType, store, { type, timeoutSuccess = true, timeoutError = true, timeoutLoading = false, success = false, error = false, loading = false }) => {
  store.commit(mutationType, {
    type: type,
    success: success,
    error: error,
    loading: loading
  });
  if (success && timeoutSuccess) {
    setTimeout(() => {
      store.commit(mutationType, {
        type: type,
        success: false,
        loading: loading
      });
    }, 2000);
  }

  if (error && timeoutError) {
    setTimeout(() => {
      store.commit(mutationType, {
        type: type,
        error: false,
        loading: loading
      });
    }, 2000);
  }

  if (loading && timeoutLoading) {
    setTimeout(() => {
      store.commit(mutationType, {
        type: type,
        loading: false
      });
    }, 2000);
  }
};

const noPreviewOrViewLivePages = (pages) => {
  const noPreviewOrViewLiveList = [];
  pages.forEach(item => {
    let needToFetch = false;
    if (!item.previewUrl) {
      //setup default previewUrl to active computed in component
      item.previewUrl = false;
      needToFetch = true;
    }
    if (!item.viewliveUrl) {
      //setup default viewliveUrl to active computed in component
      item.viewliveUrl = false;
      needToFetch = true;
    }
    if (needToFetch) {
      noPreviewOrViewLiveList.push({
        id: item.id,
        type: item.type
      });
    }
  });

  return noPreviewOrViewLiveList;
};

const actions = {
  [ACTION.UPDATE_ASSIGNMENT_COUNT]: async (store, { type }) => {
    const { state } = store;
    try {
      const res = await Api.base.post(ApiUrl.base[type]);
      if (res?.data?.pages) {
        const pages = res.data.pages;

        // TODO: Cần improve phần này: mỗi lần assign đang get all template + all preview của tất cả các template trên
        //get page item that doesn't have previewUrl or viewliveUrl to fetch later
        if (noPreviewOrViewLivePages(pages).length) {
          const payload = { noPreviewOrViewLivePages: noPreviewOrViewLivePages(pages), type: type };
          store.dispatch("fetchPreviewLink", payload);
        }
        state.pages[type].list = [...pages];
      }
    } catch (error) {
      state.pages[type].fetched = true;
      // eslint-disable-next-line no-console
      console.error(error);
    }
  },
  [ACTION.FETCH_PAGES_PAGE]: async (store, { type, onSuccess }) => {
    const { state, rootState } = store;
    const { shopInfo } = rootState.account || {};

    const isValid = checkKeyValid('onlyGetLandingPageFromGemPages', shopInfo.shopifyDomain, shopInfo.globalConfigs);

    try {
      if (!state.pages[type].fetched) {

        let url = ApiUrl.base[type];

        if (type === 'subpages' && isValid) {
          url += '?gempagesOnly=true';
        }

        const res = await Api.base.get(url);

        if (res?.data?.pages) {
          const pages = res.data.pages;

          //get page item that doesn't have previewUrl or viewliveUrl to fetch later
          // if (noPreviewOrViewLivePages(pages).length) {
          //   const payload = { noPreviewOrViewLivePages: noPreviewOrViewLivePages(pages), type: type };
          //   store.dispatch("fetchPreviewLink", payload);
          // }

          store.commit(MUTATION.PAGE_FETCH_PAGES, {
            pages,
            type: type
          });

        }
      }
      state.pages[type].fetched = true;
      if (onSuccess) onSuccess();
    } catch (error) {
      state.pages[type].fetched = true;
      // eslint-disable-next-line no-console
      console.error(error);
    }
  },
  [ACTION.FETCH_ASSIGNMENTS_PAGE]: async (store, { type, shop, onSuccess, onError }) => {
    const { state } = store;

    if (!state.assignments[type].fetched) {
      try {
        let paramsMeta = {
          shop: shop,
          key: transformPageMeta(type)
        };
        const resMeta = await Api.base.get(ApiUrl.base.assignment.shopMeta, {
          params: paramsMeta
        });
        state.assignments[type].fetched = true;
        if (resMeta?.data?.status == "success") {
          let ids = resMeta.data.metas.split(",");
          ids = ids.reverse();
          store.state.assignments[type].assignIds = ids;

          let params = {
            ids: ids,
            shop: shop,
            isDashboard: true
          };
          if (ids && ids.length) {
            const res = await Api.base.get(ApiUrl.base.assignment[type], {
              params: params
            });

            if (res?.data?.products || res?.data?.collections) {
              state.assignments[type].fetched = true;
              let pages = res.data.products || res.data.collections;
              store.commit(MUTATION.PAGE_FETCH_ASSIGNMENTS, {
                pages: pages,
                type: type
              });
            }
          }
        }

        if (onSuccess) onSuccess();
      } catch (error) {
        if (onError) onError();
      }
    }
  },
  [ACTION.NEW_PAGE_PAGE]: async (store, { params, type, onSuccess, onError }) => {
    try {
      params.pageType = transformPageType(type);
      const res = await Api.base.post(ApiUrl.base.newPage, params);
      if (res && res.data) {
        let page = res.data;
        page.__justUpdated = true;
        store.commit(MUTATION.PAGE_NEW_PAGE, {
          page: page,
          type: type
        });
        if (onSuccess) onSuccess(res.data);
      }
      // eslint-disable-next-line no-empty
    } catch (error) {
      if (onError) onError();
    }
  },
  [ACTION.CREATE_PAGE_WITH_ONE_TAP]: async ({ commit }, { type, templateId, onBoarding }) => {
    try {
      const pageTitle = generatePageTitle();
      commit(MUTATION.SET_FRAME_LOADING, { isLoading: true, typeLoading: "create_new_page" });
      commit(MUTATION.SET_DEFAULT_PAGE_NAME, pageTitle);
      const params = {
        templateId: templateId ? templateId : 0,
        pageLayout: "default",
        pageTitle: pageTitle,
        pageType: type ? transformPageType(type) : "template-page"
      };

      const res = await Api.base.post(ApiUrl.base.newPage, params);
      if (res && res.data) {
        let page = res.data;
        page.__justUpdated = true;
        commit(MUTATION.PAGE_NEW_PAGE, {
          page: page,
          type: type
        });

        let redirectEditor = page.editUrl;
        if (onBoarding && !templateId) {
          redirectEditor = page.editUrl + "&explore-template=true"; // When creating a page "blank" -> redirect to the editor and show "Explore Template"
        }
        
        window.location.href = redirectEditor;
      }
      // eslint-disable-next-line no-empty
    } catch (error) {
      commit(MUTATION.SET_FRAME_LOADING, { isLoading: false, typeLoading: "create_new_page" });
    }
  },
  [ACTION.UPDATE_PAGES_FILTER_PAGE]: async (store, { type, filter }) => {
    try {
      store.commit(MUTATION.PAGE_UPDATE_PAGES_FILTER, {
        type,
        filter
      });
    } catch (error) {
      error;
    }
  },
  [ACTION.UPDATE_PAGES_PAGINATION_PAGE]: async (store, { type, pagination }) => {
    try {
      store.commit(MUTATION.PAGE_UPDATE_PAGES_PAGINATION, {
        type,
        pagination
      });
    } catch (error) {
      error;
    }
  },
  [ACTION.DELETE_PAGE_PAGE]: async (store, { page, type, shop, onSuccess, onError }) => {
    try {
      const { state } = store;
      commitStatus(MUTATION.PAGE_UPDATE_PAGES_STATUS, store, {
        type: type,
        loading: true
      });

      let findInRecent = state.pages.recentPage.list.find(e => e.id == page.id);

      if (findInRecent) {
        commitStatus(MUTATION.PAGE_UPDATE_RECENT_STATUS, store, {
          loading: true
        });

        var recentPagesBak = JSON.parse(JSON.stringify(state.pages.recentPage.list));
        store.commit(MUTATION.PAGE_DELETE_RECENT_PAGE, {
          page
        });
      }

      var pagesBak = JSON.parse(JSON.stringify(state.pages[type].list));

      store.commit(MUTATION.PAGE_DELETE_PAGE, {
        page,
        type
      });

      let params = {
        shop: shop,
        pageId: page.id,
        pageType: transformPageType(type)
      };
      const res = await Api.base.delete(ApiUrl.base.page.deletePage, {
        params: params
      });
      if (res && res.data && res.data.status == "success") {
        if (page.is_published) {
          store.commit(MUTATION.UPDATE_PUBLISHED_COUNT, { count: -1, type });
        }
        commitStatus(MUTATION.PAGE_UPDATE_PAGES_STATUS, store, {
          type: type,
          success: true
        });
        if (findInRecent) {
          commitStatus(MUTATION.PAGE_UPDATE_RECENT_STATUS, store, {
            success: true
          });
        }
        store.commit(MUTATION.PAGE_DELETE_IN_SEARCH, {
          page
        });

        if (onSuccess) onSuccess(res);
      } else {
        state.pages[type].list = pagesBak;
        commitStatus(MUTATION.PAGE_UPDATE_PAGES_STATUS, store, {
          type: type,
          error: true
        });
        if (findInRecent) {
          state.pages.recent.list = recentPagesBak;
          commitStatus(MUTATION.PAGE_UPDATE_RECENT_STATUS, store, {
            type: type,
            error: true
          });
        }
        if (onError) onError(res);
      }
    } catch (error) {
      if (onError) onError(error);
      store.state.pages[type].list = pagesBak;
      commitStatus(MUTATION.PAGE_UPDATE_PAGES_STATUS, store, {
        type: type,
        error: true
      });
    }
  },
  [ACTION.UPDATE_PAGE_INFO_PAGE]: async (store, { page, type, headerFooter, newTitle, shop, onSuccess, onError }) => {
    // let _backup = JSON.parse(JSON.stringify(page));
    let _backup = {
      pageTitle: page.title,
      pageLayout: page.layout,
      pageHandle: page.handle
    };

    try {
      const { state, dispatch } = store;

      let params = {
        shop: shop,
        pageId: page.id,
        pageTitle: newTitle,
        pageType: transformPageType(type),
        pageLayout: headerFooter ? "default" : "blank"
      };
      let _fakeUpdated = JSON.parse(JSON.stringify(page));
      _fakeUpdated.pageTitle = newTitle;
      _fakeUpdated.pageLayout = headerFooter ? "default" : "blank";
      store.commit(MUTATION.PAGE_UPDATE_PAGE_INFO, {
        newPage: _fakeUpdated,
        type,
        oldPage: page
      });

      const enableUpdatePageV2 = await dispatch("account/checkValidKey", "theme20", { root: true });
      const url = enableUpdatePageV2 ? ApiUrl.v2.updatePage : ApiUrl.base.page.updatePage;

      const res = await Api.base.put(url, params);

      if (enableUpdatePageV2) {
        let newPage = res.data;
        newPage.__justUpdated = true;

        store.commit(MUTATION.PAGE_UPDATE_PAGE_INFO, {
          newPage,
          type,
          oldPage: page
        });

        let findInRecent = state.pages.recentPage.list.find(e => e.id == page.id);
        if (findInRecent) {
          store.commit(MUTATION.PAGE_UPDATE_PAGE_INFO_RECENT_PAGE, {
            newPage,
            oldPage: page
          });
        }

        if (onSuccess) onSuccess(res);
      } else if (res && res.data && res.data.status == "success") {
        let newPage = res.data;
        newPage.__justUpdated = true;

        store.commit(MUTATION.PAGE_UPDATE_PAGE_INFO, {
          newPage,
          type,
          oldPage: page
        });

        let findInRecent = state.pages.recentPage.list.find(e => e.id == page.id);
        if (findInRecent) {
          store.commit(MUTATION.PAGE_UPDATE_PAGE_INFO_RECENT_PAGE, {
            newPage,
            oldPage: page
          });
        }

        if (onSuccess) onSuccess(res);
      } else {
        if (onError) onError(res);
        store.commit(MUTATION.PAGE_UPDATE_PAGE_INFO, {
          newPage: _backup,
          type,
          oldPage: page
        });
      }
    } catch (error) {
      if (onError) onError(error);
      store.commit(MUTATION.PAGE_UPDATE_PAGE_INFO, {
        newPage: _backup,
        type,
        oldPage: page
      });
    }
  },
  [ACTION.MAKE_DEFAULT_PAGE]: async (store, { isTheme20, page, type, shop, onSuccess, onError }) => {
    try {
      let params = {
        shop: shop,
        pageId: page.id,
        pageType: transformPageType(type)
      };

      let apiUrl = "";
      let res;
      if (isTheme20) {
        apiUrl = ApiUrl.base.page.makeDefault20;
        res = await Api.base.post(apiUrl, params);
      } else {
        apiUrl = ApiUrl.base.page.makeDefault;
        res = await Api.base.get(apiUrl, {
          params: params
        });
      }

      if (res && res.data && res.data.status == "success") {
        if (!(PAGE_DEFAULT_TITLE[page.title] || page.is_published)) {
          store.commit(MUTATION.UPDATE_PUBLISHED_COUNT, { count: 1, type });
        }
        page.__justUpdated = true;
        store.commit(MUTATION.PAGE_MAKE_DEFAULT, {
          page: page,
          type
        });

        //UPDATE_PUBLISHED_COUNT
        if (onSuccess) onSuccess(res);
      } else {
        throw res;
      }
    } catch (error) {
      if (onError) onError(error);
    }
  },
  [ACTION.FETCH_TEMPLATES_PAGE]: async (store, { shop, tags, onSuccess }) => {
    try {
      if (!store.state.templates.fetched) {
        let params = {
          shop: shop,
          tags: tags
        };
        const res = await Api.base.get(ApiUrl.base.template.allTemplates, {
          params: params
        });
        if (res && res.data && res.data.templates) {
          store.commit(MUTATION.PAGE_FETCH_TEMPLATES, {
            templates: res.data.templates,
            tags
          });
        }
      }
      if (onSuccess) onSuccess();
    } catch (error) {
      store;
    }
  },
  [ACTION.ASSIGN_TEMPLATE_PAGE]: async (store, { shop, type, templateId, assignId, onSuccess, onError }) => {
    try {
      let params = {
        shop: shop,
        type: transformPageType(type),
        template_id: templateId
      };
      if (type == "productpages") {
        params.product_id = assignId;
      }
      if (type == "collectionpages") {
        params.collection_id = assignId;
      }
      const res = await Api.base.get(ApiUrl.base.assignment.assign[type], {
        params: params
      });
      if (res && res.data && res.data.status == "success") {
        store.commit(MUTATION.PAGE_ASSIGN_TEMPLATE, {
          assignId,
          templateId,
          type
        });

        if (onSuccess) onSuccess(res);
      } else {
        throw "error";
      }
    } catch (error) {
      if (onError) onError(error);
    }
  },
  [ACTION.FETCH_NEWEST_ITEMS_PAGE]: async (store, { shop, type, onSuccess, onError }) => {
    const { state } = store;
    try {
      if (!state.assignments.newestItems[type].fetched) {
        let params = {
          shop: shop,
          limit: 10,
          fields: "id,handle,title,image,template_suffix,updated_at"
        };
        const res = await Api.base.get(ApiUrl.base.assignment.newestItems[type], {
          params: params
        });

        state.assignments.newestItems[type].fetched = true;

        if (res.data.collections || res.data.products) {
          store.commit(MUTATION.PAGE_FETCH_NEWEST_ITEMS, {
            pages: res.data.collections || res.data.products,
            type: type
          });
        }
      }
      if (onSuccess) onSuccess();
    } catch (error) {
      state.assignments.newestItems[type].fetched = true;
      if (onError) onError(error);
    }
  },
  [ACTION.FETCH_ALL_ITEMS]: (store, { shop, type }) => {
    return new Promise(async (resolve, reject) => {
      const { state } = store;
      try {
        if (!state.assignments[type].fetched) {
          let params = {
            shop: shop,
            limit: "30",
            fields: "id,handle,title,image,template_suffix,updated_at,status,published_at",
            // custom_fields: "total"
            isDashboard: true
          };
          const res = await Api.base.get(ApiUrl.base.assignment.all[type], {
            params: params
          });

          state.assignments[type].fetched = true;

          if (res.data.collections || res.data.products) {
            store.commit(MUTATION.PAGE_FETCH_ALL_ITEMS, {
              items: res.data.collections || res.data.products,
              type: type,
              total: res.data.total
            });
          }
        }
        resolve();
      } catch (error) {
        reject(error);
        state.assignments[type].fetched = true;
      }
    });
  },
  [ACTION.FETCH_ALL_ASSIGN_ITEMS]: (store, { shop, type }) => {
    return new Promise(async (resolve, reject) => {
      const { state } = store;
      try {
        if (!state.assignments[type].fetchedAssign) {
          let params = {
            shop: shop,
            limit: 10,
            fields: "id,handle,title,image,template_suffix,updated_at,status,published_at",
            notFetchMetafields: 1
          };
          const res = await Api.base.get(ApiUrl.base.assignment.get[type], {
            params: params
          });

          state.assignments[type].fetchedAssign = true;

          if (res.data.collections || res.data.products) {
            store.commit(MUTATION.PAGE_FETCH_ALL_ITEMS, {
              items: res.data.collections || res.data.products,
              type: type,
              total: res.data.total
            });
          }
        }
        resolve();
      } catch (error) {
        reject(error);
        state.assignments[type].fetchedAssign = true;
      }
    });
  },

  [ACTION.SEARCH_ANYTHING_PAGE]: (store, query) => {
    return new Promise(async (resolve, reject) => {
      if (query.trim()) {
        store.commit(MUTATION.PAGE_UPDATE_SEARCH_LOADING, true);
      }
      store.commit(MUTATION.PAGE_UPDATE_SEARCH_QUERY, query);
      try {
        let res = await Api.base.get(ApiUrl.base.search, {
          params: { s: query }
        });
        if (res.data.status == "success") {
          store.commit(MUTATION.PAGE_APPEND_SEARCH_DATA, {
            pages: res.data.pages,
            templates: res.data.templates,
            faqs: res.data.faqs
          });
        } else {
          reject(res.data);
        }
      } catch (error) {
        reject(error);
      }
      store.commit(MUTATION.PAGE_UPDATE_SEARCH_LOADING, false);
    });
  },

  [ACTION.SEARCH_ITEMS]: (store, { type = "productpages", shop, query }) => {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await Api.base.get(ApiUrl.base.assignment.search[type], {
          params: {
            shop: shop,
            s: query
          }
        });
        let data = res.data.products || res.data.collections;
        store.commit(MUTATION.SEARCH_ITEMS, { data, type });
        resolve(res);
      } catch (error) {
        reject(error);
      }
    });
  },

  [ACTION.SET_GROUP_ID_PAGE]: (store, { data, group_id, pageType }) => {
    return new Promise(async (resolve, reject) => {
      try {
        let postData = {
          data: data,
          pageType: transformPageType(pageType)
        };
        if (group_id) {
          postData.groupId = group_id;
        }

        let res = await Api.base.put(ApiUrl.base.page.assignGroup, postData);

        if (res.data.status == "error") {
          throw res.data.message;
        }
        resolve(res);

        postData.pageType = pageType;
        postData.__justUpdated = true;

        store.commit(MUTATION.PAGE_SET_GROUP_ID, postData);
      } catch (error) {
        reject(error);
      }
    });
  },

  [ACTION.VIEW_TEMPLATE]: (store, { id }) => {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await Api.base.put(ApiUrl.base.template.view(id));
        if (res.data && res.data.status == "success") {
          store.commit(MUTATION.PAGE_INCREASE_VIEW_TEMPLATE, { id, inc: 1 });
          resolve(res);
        } else {
          reject(res);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  [ACTION.PUBLISH_PAGE]: async (store, { id, onLoading, onSuccess, onError }) => {
    onLoading();
    let method = process.env.NODE_ENV == "development" ? "get" : "post";
    try {
      if (process.env.NODE_ENV == "development") {
        let delay = new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, 1500);
        });
        await delay;
      }
      let res = await Api.base[method](ApiUrl.base.page.linkPage(id));
      if (res.data && res.data.status == "success") {
        store.commit(MUTATION.PAGE_SWITCH_PUBLISH, { type: "subpages", id: id });
        onSuccess(res);
      } else {
        throw res.data;
      }
    } catch (error) {
      if (error.response) {
        onError(error.response.data);
      } else {
        onError(error);
      }
    }
  },
  [ACTION.UNPUBLISH_PAGE]: async (store, { id, type, onLoading, onSuccess, onError }) => {
    onLoading();
    let method = process.env.NODE_ENV == "development" ? "get" : "post";
    try {
      let res = await Api.base[method](ApiUrl.base.page.unlinkPage(id));
      if (res.data && res.data.status == "success") {
        store.commit(MUTATION.UPDATE_PUBLISHED_COUNT, { count: -1, type });
        store.commit(MUTATION.PAGE_SWITCH_PUBLISH, { type: type, id: id });
        onSuccess(res);
      } else {
        throw res.data;
      }
    } catch (error) {
      if (error.response) {
        onError(error.response.data);
      } else {
        onError(error);
      }
    }
  },
  [ACTION.DUPLICATE_TO]: (store, { id, to, pageTitle }) => {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await Api.base.get(ApiUrl.base.page.duplicateTo, {
          params: {
            id: id,
            to: to,
            pageTitle: pageTitle ? pageTitle : ""
          }
        });
        if (res.data && res.data.status == "success") {
          let page = res.data.page;
          let pageType = "";
          switch (to) {
            case "template-page":
              pageType = "subpages";
              break;
            case "template-article":
              pageType = "articlepages";
              break;
            case "template-index":
              pageType = "homepages";
              break;
            case "template-product":
              pageType = "productpages";
              break;
            case "template-collection":
              pageType = "collectionpages";
              break;
          }
          page.__justUpdated = true;

          store.commit(MUTATION.DUPLICATE_TO, { page: page, type: pageType });
          resolve(res);
        } else {
          reject(res);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  [ACTION.MODIFY_LAYOUT]: (store, { id, type, layout }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await Api.base.put(ApiUrl.base.page.modifyLayout, {
          id: id,
          type: type,
          layout: layout
        });

        if (res && res.data && res.data.status == "success") {
          store.commit(MUTATION.MODIFY_LAYOUT, { id: id, type: type, layout: layout });
          resolve(res);
        } else {
          reject();
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  [ACTION.CLONE_PAGE_PAGE_V2]: async (store, { page, type, pageTitle, onSuccess, onError }) => {
    const thumbnail = page.thumbnail_url;
    let _fakePage = JSON.parse(JSON.stringify(page));
    _fakePage.id = -9999;
    _fakePage.title = "Copy of " + _fakePage.title;
    _fakePage.created_at = Date.now();
    _fakePage.updated_at = Date.now();
    _fakePage.thumbnail_url = thumbnail;
    try {
      const { state } = store;
      let params = {
        pageId: page.id,
        pageType: transformPageType(type),
        pageTitle: pageTitle ? pageTitle : ""
      };
      // go to page 1 and prepend fake data
      store.commit(MUTATION.PAGE_UPDATE_PAGES_PAGINATION, { type, pagination: { page: 1 } });
      let _fakePageIndex = state.pages[type].list.find(e => e.id == _fakePage.id);
      if (_fakePageIndex > -1) {
        state.pages[type].list.slice(_fakePageIndex, 1);
      }

      const res = await Api.base.put(ApiUrl.base.v2.clonePage, params);

      if (res && res.data && res.data.status == "success") {
        let page = res.data;
        page.thumbnail_url = thumbnail;
        page.__justUpdated = true;
        page.isGpTemplate = true;
        // commit into mutation
        store.commit(MUTATION.PAGE_CLONE_PAGE, {
          newPage: page,
          type,
          groupID: page.page_group_id
        });

        let findInRecent = state.pages.recentPage.list.find(e => e.id == page.id);
        if (findInRecent) {
          store.commit(MUTATION.PAGE_CLONE_RECENT_V2_PAGE, {
            newPage: res.data
          });
        }

        if (onSuccess) onSuccess(res);
      } else {
        if (onError) onError(res);
      }
    } catch (error) {
      if (onError) onError(error);
      let ind = store.state.pages[type].list.find(item => item.id == _fakePage.id);
      if (ind > -1) {
        store.state.pages[type].list.splice(ind, 1);
      }
    }
  },
  updateRunningCampaignId({ state, rootState }, { id }) {
    const attach = rootState.analytic.attach;
    const pageType = getPageListName(attach.page_type);

    const needUpdatingPageIds = attach.pages.map(page => page.g_id);
    const pagesList = state.pages[pageType].list;
    const recentPageList = state.pages.recentPage.list;
    const updateRunningCampaignIdInPagesList = page => {
      if (needUpdatingPageIds.includes(page.id)) {
        page.runningCampaignId = id;
      }
    };
    pagesList.forEach(updateRunningCampaignIdInPagesList);
    recentPageList.forEach(updateRunningCampaignIdInPagesList);
  },
  async fetchPreviewLink({ state }, payload) {
    const { noPreviewOrViewLivePages, type } = payload;
    const res = await Api.base.post(ApiUrl.base.fetchPreviewLink, {
      pages: noPreviewOrViewLivePages
    });

    if (res.data?.pages) {
      const resPages = res.data.pages;
      const pageLists = cloneDeep(state.pages);
      resPages.forEach(page => {
        const pageList = getPageListName(page.type);
        let originalPage;
        if (type == "recentPage") {
          originalPage = pageLists[type].list.find(item => item.id === page.id);
        } else {
          originalPage = pageLists[pageList].list.find(item => item.id === page.id);
        }
        if (originalPage) {
          originalPage.previewUrl = page.previewUrl;
          originalPage.viewliveUrl = page.viewliveUrl;
        }
      });
      state.pages = pageLists;
    }
  },
  [ACTION.UNPUBLISH_PAGE_BY_ID](store, { pageId, pageType }) {
    return new Promise(async (resolve, reject) => {
      try {
        const payload = {
          ids: [pageId]
        };
        const res = await Api.base.post(ApiUrl.base.downgrade.unpublish, payload);
        resolve(res.data);
        store.commit(MUTATION.UPDATE_PUBLISHED_COUNT, { count: -1, type: pageType });
      } catch (e) {
        reject(e);
      }
    });
  }
};

export default actions;
